/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getTopupReceipt, getUserDetails } from '../../api/profileApi';
import {
  getValueFromAppConfig,
  getUserAgentId,
} from '../../shared/helper-utils/localStorage';
import {
  hideHeaderFooter,
  showHeaderFooter,
} from '../../shared/helper-utils/appUtils';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import { useAppContext } from '../../saas/AppConfigWrapper';

function TopupReceiptPage() {
  const { appConfig } = useAppContext();
  const { transactionId } = useParams();
  const [agent, setAgent] = useState(undefined);
  const [receipt, setReceipt] = useState(undefined);
  const [hasDetails, setHasDetails] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const showHeaderAndFooter =
      getValueFromAppConfig('UAEclient') === true ||
      getValueFromAppConfig('UAEclient') === 'true';

    if (showHeaderAndFooter) {
      showHeaderFooter();
    } else {
      hideHeaderFooter();
    }
    return () => showHeaderFooter();
  }, []);

  const getData = async (txid) => {
    setIsLoading(true);
    const res = await getUserDetails(getUserAgentId());
    if (res?.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      setAgent(User);
      if (txid) {
        const response = await getTopupReceipt(txid);
        if (response?.Root?.Status === 'OK') {
          const { Receipt } = response.Root.Result;
          setReceipt(Receipt);
          setHasDetails(true);
        }
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData(transactionId);
  }, [transactionId]);
  return (
    <section className="credit-debit-note">
      <section className="print-links d-flex flex-column hide-in-print">
        <a onClick={() => window.print()}>
          <img src="/images/others/print_sidebutton.png" alt="" />
        </a>
        <a href={NAVIGATION_ROUTES.LANDING}>
          <img src="/images/others/home_sidebutton.png" alt="" />
        </a>
      </section>
      <AppLoading isLoading={isLoading} />
      {hasDetails ? (
        <section className="credit-debit-note_container">
          <div className="d-flex flex-column">
            <div className="fs-4 fw-600">
              <span>PAYMENT RECEIPT</span>
            </div>
            <div className="d-flex flex-column align-items-end fs-5 fw-600">
              <span>Receipt Number :</span>
              <span>Receipt Date :</span>
            </div>
          </div>
          <div className="d-flex flex-column mb-1">
            <span>{getValueFromAppConfig('COMPANYNAME')}</span>
            <span>{getValueFromAppConfig('COMPANYADD')}</span>
          </div>
          <div>
            <h5>To</h5>
            {agent && (
              <table className="w-100 agency-details mb-1">
                <tbody>
                  <tr>
                    <td>Agency Name:</td>
                    <td>{agent.Company}</td>
                  </tr>
                  <tr>
                    <td>Address:</td>
                    <td className="d-flex flex-column">
                      <span>{agent.Address1}</span>
                      <span>
                        {agent.City},{agent.PinCode},{agent.Country}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>Email:</td>
                    <td>{agent.ContactEmail}</td>
                  </tr>
                  <tr>
                    <td>Contact:</td>
                    <td>{agent.ContactNumber}</td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>
          <div>
            <h5>Details</h5>
            <table className="transaction-details mb-2">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Particulars</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Approval Date</td>
                  <td>{receipt.ApprovalDate}</td>
                </tr>
                <tr>
                  <td>TransactionID</td>
                  <td>{receipt.Txid}</td>
                </tr>
                <tr>
                  <td>Payment Mode</td>
                  <td>{receipt.PaymentMode}</td>
                </tr>
                <tr>
                  <td>Cheque/DD No.</td>
                  <td>{receipt.ChequeDDNo}</td>
                </tr>
                <tr>
                  <td>Cheque/DD Date</td>
                  <td>{receipt.ChequeDDDate}</td>
                </tr>
                <tr>
                  <td>Deposited Bank & Branch</td>
                  <td>
                    {receipt.DepositedBank}-{receipt.DepositedBranch}
                  </td>
                </tr>
                <tr>
                  <td>Deposited Amount</td>
                  <td>{receipt.DepositedAmount}</td>
                </tr>
                <tr>
                  <td>Approved Amount {appConfig?.appCurrency}</td>
                  <td>{receipt.ApprovedAmount}</td>
                </tr>
                <tr>
                  <td>Approved By</td>
                  <td>{receipt.ApprovedBy}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>{receipt.Status}</td>
                </tr>
                <tr>
                  <td>Admin Remarks</td>
                  <td>{receipt.AdminRemarks}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="fw-bold">
            ps: Being a computer generated statement, signature not required
          </div>
        </section>
      ) : (
        <div className="d-flex justify-content-center p-5">
          <p> No Receipt Found</p>
        </div>
      )}
    </section>
  );
}

export default TopupReceiptPage;
